/**
 * Sapio null rule, made concrete (brief §8.1 — the single highest-severity
 * risk in the feature).
 *
 * A null / undefined / not-established carrier field MUST resolve to 'unknown',
 * never 'non_carrier'. Templates must not assert non-carrier status on
 * 'unknown'. Absence of evidence is never a negative clinical assertion.
 *
 * @typedef {'carrier' | 'non_carrier' | 'unknown'} CarrierState
 */

export const CARRIER_STATE = Object.freeze({
  CARRIER: 'carrier',
  NON_CARRIER: 'non_carrier',
  UNKNOWN: 'unknown'
});

/**
 * @param {{ established?: boolean, isCarrier?: boolean } | null | undefined} raw
 * @returns {CarrierState}
 */
export function resolveCarrierState(raw) {
  if (raw == null) return CARRIER_STATE.UNKNOWN;
  if (raw.established !== true) return CARRIER_STATE.UNKNOWN;
  return raw.isCarrier ? CARRIER_STATE.CARRIER : CARRIER_STATE.NON_CARRIER;
}

/** Human-facing display for a resolved carrier state (never used for 'unknown'). */
export function carrierDisplay(state) {
  if (state === CARRIER_STATE.CARRIER) return 'Carrier';
  if (state === CARRIER_STATE.NON_CARRIER) return 'Not a carrier';
  return ''; // 'unknown' asserts nothing
}
